
var SCM = SCM || {};

SCM.CitedByPagination = (function ($) {

    var baseUrl;
    var articleId;

    return {
        init: init,
        handlePaginationClick: handlePaginationClick
    };

    function init() {
        if ($('.widget-CrossRefCitedBy').length) {
            baseUrl = SCM.Pagination.trimEndUntilRegexMatches(document.URL.valueOf(), /[a-zA-Z]\/\d+$/);
            articleId = getArticleIdFromUrl(baseUrl);

            SCM.Pagination.enableBrowserHistoryNavigation();
        }
    }

    function getArticleIdFromUrl(baseUrl) {
        return baseUrl.match(/[a-zA-Z]\/(\d+)$/)[1];
    }

    function handlePaginationClick(jqElement) {
        SCM.Pagination.updateBrowseHistory(baseUrl, baseUrl + '/' + jqElement.data('clicked-page'));

        var ajaxSettings = {
            type: 'POST',
            url: (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') +
                '/ThirdParty/CrossRefCitedBy/' +
                jqElement.data('parent-instance'),
            cache: false,
            data: {
                selectedPage: jqElement.data('clicked-page'),
                articleId: articleId
            }
        };

        SCM.Pagination.performAjaxPagination(ajaxSettings, jqElement);
    }

})(jQuery);

jQuery(function () {
    SCM.CitedByPagination.init();
});